import React from 'react';
import cx from 'classnames';

interface DividerProps {
  /**
   *  To add additional className
   */
  className?: string;

  /**
   *  To change variant style of divider
   */
  variant?: 'regular' | 'deboss';
}

const Divider = ({ className, variant = 'regular' }: DividerProps) => (
  <hr className={cx('divider', variant, className && className)} />
);

export default Divider;
